import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["field"];

  connect() {
    console.log("Form validation controller connected");

    // Add listeners for all field targets
    this.fieldTargets.forEach((field) => {
      field.addEventListener("change", () => {
        this.validate();
      });
    });

    // Run validation on load
    setTimeout(() => {
      this.validate();
    }, 100);
  }

  validate() {
    const submitButton = document.getElementById("btnContinue");
    const disabledButton = document.getElementById("btnContinueDisabled");

    if (!submitButton || !disabledButton) {
      console.error("Form validation: buttons not found");
      return;
    }

    // Check if at least one feature interest checkbox is checked
    const checkedInterests = document.querySelectorAll('input[name="user[feature_interests][]"]:checked');
    const hasInterest = checkedInterests.length > 0;

    // Check if industry dropdown has a value
    const industrySelect = document.getElementById("user_industry");
    const hasIndustry = industrySelect && industrySelect.value && industrySelect.value.length > 0;

    // Check if partner matching radio is selected
    const checkedPartner = document.querySelector('input[name="user[wants_partner_matching]"]:checked');
    const hasPartnerChoice = checkedPartner !== null;

    const isValid = hasInterest && hasIndustry && hasPartnerChoice;

    console.log('Validation:', {
      hasInterest,
      hasIndustry,
      hasPartnerChoice,
      isValid
    });

    // Toggle button visibility
    if (isValid) {
      submitButton.classList.remove("d-none");
      submitButton.classList.add("d-block");
      disabledButton.classList.add("d-none");
      disabledButton.classList.remove("d-block");
    } else {
      disabledButton.classList.remove("d-none");
      disabledButton.classList.add("d-block");
      submitButton.classList.add("d-none");
      submitButton.classList.remove("d-block");
    }
  }
}
